import React, { useCallback, useState } from "react"

import { type LeadWorkspacePatch } from "../../../Lead/LeadWorkspacePage/lead-workspace-patch.ts"
import { LeadOverviewTab } from "../../../Lead/LeadWorkspacePage/overview/LeadOverviewTab.tsx"
import { type Lead } from "../../../Lead/types/lead.types.ts"
import {
  TOUR_DEMO_LEAD_FILTER_OPTIONS,
  TOUR_DEMO_LEAD_RECORD
} from "../../content/tour-demo-data.ts"

/**
 * The REAL Lead Overview tab (`LeadOverviewTab`, presentational — confirmed
 * with no internal `useSelector`/`connect`) fed local demo state instead of
 * the real `onPatch` thunk chain. Edits made during the tour update this
 * component's own `useState` only and are never sent to the API.
 */
export const DemoLeadOverviewSection = () => {
  const [lead, setLead] = useState<Lead>(TOUR_DEMO_LEAD_RECORD)

  const onPatch = useCallback(async (patch: LeadWorkspacePatch) => {
    setLead((prev) => ({ ...prev, ...patch }) as Lead)
    return true
  }, [])

  const onTabChange = useCallback(() => {}, [])
  const onChecklistUpdate = useCallback(async () => {}, [])
  const onLeadSelect = useCallback(() => {}, [])
  const onStageChange = useCallback(() => {}, [])

  return (
    <LeadOverviewTab
      lead={lead}
      canEdit
      saving={false}
      filterOptions={TOUR_DEMO_LEAD_FILTER_OPTIONS}
      leadPermissions={{} as never}
      onPatch={onPatch}
      onTabChange={onTabChange}
      onChecklistUpdate={onChecklistUpdate}
      onLeadSelect={onLeadSelect}
      onStageChange={onStageChange}
    />
  )
}
